#import "../fragments/account-page-fragment.graphql"

query GetAccount($id: ID!) {
    account(id: $id) {
        ...AccountPageFragment
    }
}
